import $ from 'jquery'
import 'paroller.js'

$(document).ready(function () {
  $('.dhsv_vc_guidebook_teaser').each(function (i, el) {
    $(el).paroller({
      factor: 0.15,
    })
  })
})
